import {
  withTranslation,
} from 'react-i18next';

import ChampionshipDocumentsSectionView from './ChampionshipDocumentsSectionView';

const TranslatedComponent = withTranslation()(ChampionshipDocumentsSectionView);

const Component = TranslatedComponent;

export default Component;
